/**
 * Renewal Reminders API
 * RTK Query endpoints for renewal reminder management
 */

import { baseApi } from "./baseApi";

/**
 * Renewal reminder response interface
 */
export interface RenewalReminderResponse {
	success: boolean;
	message: string;
	result: {
		total_leases: number;
		tenant_emails_sent: number;
		admin_emails_sent: number;
		tenant_notifications_created: number;
		admin_notifications_created: number;
		errors: string[];
	};
}

/**
 * Renewal Reminders API endpoints
 */
export const renewalRemindersApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		/**
		 * Trigger renewal reminders
		 */
		sendRenewalReminders: builder.mutation<
			RenewalReminderResponse,
			{ days_before_expiry?: number }
		>({
			query: (params = {}) => {
				const queryParams = new URLSearchParams();
				if (params.days_before_expiry) {
					queryParams.append(
						"days_before_expiry",
						params.days_before_expiry.toString(),
					);
				}
				return {
					url: `/renewal-reminders/send-reminders?${queryParams.toString()}`,
					method: "POST",
				};
			},
		}),
	}),
});

/**
 * Export hooks for usage in functional components
 */
export const { useSendRenewalRemindersMutation } = renewalRemindersApi;
